import { getAppInfo, getAppID } from '@/utils/base'

export const loverflixTemplate = () => {
    return getAppID() === 'loverflix' || getAppID() === 'polarnovel'
}



export default {
    discover_tab: 'Discover',
    mine_tab: 'Mine',
    bookshelf_tab: 'Bookshelf',
    ranking: 'Ranking',
    more: 'More',
    search_stories: 'Search Stories',
    'you_might_like': 'You Might Like',
    'chapter': 'chapters',
    'chapters': 'Chapters',
    'completed': 'Completed',
    'reviews': 'Reviews',
    'words': 'Words',
    'summary': 'Summary',
    'read_now': 'Read Now',
    'add_to_library': 'Add to Library',
    'select_payment_method': 'Select payment method',
    'most_popular': 'Most popular',
    'weekly': 'Weekly',
    'subscribe': 'Subscribe',
    'login': 'Login',
    'register': 'Register',
    'logout': 'Logout',
    'sign_in_to_get_more': 'Sign in to get more',
    'vip_status_inactive': 'Vip status: inactive',
    'vip_activated': 'VIP activated',
    'active_wireless_reading_now': 'Active wireless reading now',
    'question': 'Customer Center',
    'terms_of_service': 'Terms of service',
    'privacy_policy': 'Privacy policy',
    'search': 'Search',
    'user': 'User',
    'password': 'Password',
    'by_continuing_you_agree_with_the': 'By continuing, you agree with the ',
    'and': 'and',
    'username_or_password_cannot_be_empty': 'Username or Password cannot be empty',
    'username_or_password_length_must_be_greater_than_8': 'Username or Password length must be greater than 8',
    'register_success': 'Register success',
    'login_success': 'Login success',
    'logout_success': 'Logout success',
    'rules': 'Rules',
    'vip_member_benefits': 'VIP member benefits',
    'bookshelf_none': 'There are no books on the bookshelf. Go to the bookstore to pick out the books you like.',
    'go_to_the_bookstore': 'Go to the bookstore',
    'search_none': `It looks like you haven't consumed before`,
    'go_to_pay': 'You will be redirected to pay Shortly.',
    'continue': 'Continue',
    'PRIVACY': {
        content: getAppInfo().privacy || `
    <h2>Privacy Policy</h2>
    <p>Effective Date: February 5, 2026</p>
    <p>Welcome to AI Swap (hereinafter referred to as “the Service”, “we”, or “us”).</p>
    <p>We value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, store, and protect information when you access or use our web-based services.</p>

    <h2>1. Information We Collect</h2>
    <p>To provide our AI-powered services, we collect the following categories of information:</p>

    <h3>1.1 Information You Provide</h3>
    <ul>
        <li>Media Content: Photos or images that you voluntarily upload for generating AI-based visual effects such as face swap, photo animation, or AI-generated portraits.</li>
        <li>Face Data: Facial feature data contained within the Media Content you upload, used solely to generate the requested visual output.</li>
        <li>Contact Information: If you contact us directly, we may collect your email address and the content of your communication.</li>
    </ul>

    <h3>1.2 Automatically Collected Information</h3>
    <p>To ensure service functionality, security, and performance measurement, we may automatically collect:</p>
    <ul>
        <li>IP address and network information</li>
        <li>Device and browser information (such as device model, operating system, and browser type)</li>
        <li>Service usage logs (e.g., feature interactions and access timestamps)</li>
        <li>Advertising-related technical signals used for campaign performance measurement, where applicable</li>
    </ul>

    <h2>2. How We Use Information</h2>
    <p>We use the collected information only for legitimate and necessary purposes, including:</p>
    <ul>
        <li>Providing, maintaining, and operating AI-powered face swap and photo animation services.</li>
        <li>Processing Media Content through AI models to generate user-requested results.</li>
        <li>Responding to user inquiries and service-related communications.</li>
        <li>Performing aggregated and anonymized analytics to improve service performance and stability.</li>
        <li>Measuring advertising performance and campaign effectiveness, where applicable.</li>
        <li>Protecting service security and preventing fraud, abuse, or unauthorized access.</li>
    </ul>

    <h3>2.1 Face Data Processing and Retention (Important)</h3>
    <p>Face Data is considered sensitive personal information and is handled under strict limitations:</p>
    <ul>
        <li>Face Data is used only to generate the specific content explicitly requested by the user during a single service session.</li>
        <li>The Service does not perform facial recognition, identity verification, biometric identification, profiling, or determine whether a face belongs to a specific real individual.</li>
        <li>Face Data is never used for advertising, tracking, personalization, analytics, or attribution purposes.</li>
        <li>Face Data is not combined with advertising-related data or technical signals.</li>
        <li>We do not use Face Data to train general-purpose AI models or to develop unrelated products or services.</li>
    </ul>

    <h4>Retention Policy</h4>
    <ul>
        <li>Uploaded original photos are automatically and permanently deleted immediately after AI processing is completed.</li>
        <li>Generated results are temporarily stored in secure cloud storage to allow user access and are automatically deleted from our servers after 7 days.</li>
        <li>After deletion, the content cannot be recovered.</li>
    </ul>

    <h2>3. Information Sharing</h2>
    <p>We take the protection of your personal information seriously.</p>
    <p>We do not sell personal information.</p>
    <p>We share information only in the following limited circumstances:</p>

    <h3>3.1 Service Providers (Data Processors)</h3>
    <p>We engage trusted third-party service providers strictly to operate core service functionality:</p>
    <h4>Cloud Infrastructure & Storage</h4>
    <p>Tencent Cloud is used to securely process and temporarily store data.</p>
    <p>Privacy Policy: <a href="https://privacy.qq.com" target="_blank">https://privacy.qq.com</a></p>

    <h4>AI Content Generation</h4>
    <p>Replicate is used solely to process uploaded Media Content for generating AI effects such as face swap or photo animation.</p>
    <p>Replicate acts strictly as a data processor under contractual obligations and is prohibited from retaining, reusing, or repurposing any data.</p>
    <p>Face Data is transmitted only for one-time processing and is not retained after processing is completed.</p>
    <p>Privacy Policy: <a href="https://replicate.com/privacy" target="_blank">https://replicate.com/privacy</a></p>

    <h3>3.2 Advertising & Analytics Partners</h3>
    <p>To measure advertising performance and understand the effectiveness of our marketing campaigns, we may share limited, non-face, non-identifying information (such as device information or aggregated usage data) with the following partner:</p>
    <ul>
        <li>Meta Platforms, Inc. (Facebook)</li>
        <li><a href="https://www.facebook.com/privacy/policy" target="_blank">https://www.facebook.com/privacy/policy</a></li>
    </ul>
    <p>Face Data and uploaded Media Content are never shared with advertising or analytics partners.</p>

    <h3>3.3 Legal and Safety Requirements</h3>
    <p>We may disclose information if required to comply with applicable laws, legal processes, or to protect the rights, safety, or property of users or the public.</p>

    <h2>4. Information Security</h2>
    <p>We implement reasonable technical and organizational measures to protect information from unauthorized access, disclosure, alteration, or destruction. Access to personal information is restricted to authorized personnel on a need-to-know basis.</p>

    <h2>5. Your Rights</h2>
    <p>Depending on applicable laws, you may have the right to:</p>
    <ul>
        <li>Access or correct your personal information</li>
        <li>Request deletion of your personal information</li>
    </ul>
    <p>You may submit requests by contacting us at:</p>
    <p>ops@novellettes.com</p>
    <p>Certain information may be retained where required by law or for legitimate security purposes.</p>

    <h2>6. Third-Party Links and Services</h2>
    <p>This Privacy Policy applies only to information collected by AI Swap.</p>
    <p>Third-party websites, platforms, or services are governed by their own privacy policies.</p>

    <h2>7. Policy Updates</h2>
    <p>We may update this Privacy Policy from time to time. Any changes will be reflected by an updated “Effective Date” at the top of this page. Material changes may be communicated through appropriate notices.</p>

    <h2>8. Contact Us</h2>
    <p>If you have any questions about this Privacy Policy or our data practices, please contact us at:</p>
    <p>ops@novellettes.com</p>
        `
    },
    SERVICE: {
        content: getAppInfo().service || `
            <h1>Use of terms</h1>
            <p>Effective Date: February 5, 2026</p>
    <p>Welcome to AI Swap (hereinafter referred to as “the Service”, “we”, or “us”).</p>
    <p>We value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, store, and protect information when you access or use our web-based services.</p>

    <h2>1. Information We Collect</h2>
    <p>To provide our AI-powered services, we collect the following categories of information:</p>

    <h3>1.1 Information You Provide</h3>
    <ul>
        <li>Media Content: Photos or images that you voluntarily upload for generating AI-based visual effects such as face swap, photo animation, or AI-generated portraits.</li>
        <li>Face Data: Facial feature data contained within the Media Content you upload, used solely to generate the requested visual output.</li>
        <li>Contact Information: If you contact us directly, we may collect your email address and the content of your communication.</li>
    </ul>

    <h3>1.2 Automatically Collected Information</h3>
    <p>To ensure service functionality, security, and performance measurement, we may automatically collect:</p>
    <ul>
        <li>IP address and network information</li>
        <li>Device and browser information (such as device model, operating system, and browser type)</li>
        <li>Service usage logs (e.g., feature interactions and access timestamps)</li>
        <li>Advertising-related technical signals used for campaign performance measurement, where applicable</li>
    </ul>

    <h2>2. How We Use Information</h2>
    <p>We use the collected information only for legitimate and necessary purposes, including:</p>
    <ul>
        <li>Providing, maintaining, and operating AI-powered face swap and photo animation services.</li>
        <li>Processing Media Content through AI models to generate user-requested results.</li>
        <li>Responding to user inquiries and service-related communications.</li>
        <li>Performing aggregated and anonymized analytics to improve service performance and stability.</li>
        <li>Measuring advertising performance and campaign effectiveness, where applicable.</li>
        <li>Protecting service security and preventing fraud, abuse, or unauthorized access.</li>
    </ul>

    <h3>2.1 Face Data Processing and Retention (Important)</h3>
    <p>Face Data is considered sensitive personal information and is handled under strict limitations:</p>
    <ul>
        <li>Face Data is used only to generate the specific content explicitly requested by the user during a single service session.</li>
        <li>The Service does not perform facial recognition, identity verification, biometric identification, profiling, or determine whether a face belongs to a specific real individual.</li>
        <li>Face Data is never used for advertising, tracking, personalization, analytics, or attribution purposes.</li>
        <li>Face Data is not combined with advertising-related data or technical signals.</li>
        <li>We do not use Face Data to train general-purpose AI models or to develop unrelated products or services.</li>
    </ul>

    <h4>Retention Policy</h4>
    <ul>
        <li>Uploaded original photos are automatically and permanently deleted immediately after AI processing is completed.</li>
        <li>Generated results are temporarily stored in secure cloud storage to allow user access and are automatically deleted from our servers after 7 days.</li>
        <li>After deletion, the content cannot be recovered.</li>
    </ul>

    <h2>3. Information Sharing</h2>
    <p>We take the protection of your personal information seriously.</p>
    <p>We do not sell personal information.</p>
    <p>We share information only in the following limited circumstances:</p>

    <h3>3.1 Service Providers (Data Processors)</h3>
    <p>We engage trusted third-party service providers strictly to operate core service functionality:</p>
    <h4>Cloud Infrastructure & Storage</h4>
    <p>Tencent Cloud is used to securely process and temporarily store data.</p>
    <p>Privacy Policy: <a href="https://privacy.qq.com" target="_blank">https://privacy.qq.com</a></p>

    <h4>AI Content Generation</h4>
    <p>Replicate is used solely to process uploaded Media Content for generating AI effects such as face swap or photo animation.</p>
    <p>Replicate acts strictly as a data processor under contractual obligations and is prohibited from retaining, reusing, or repurposing any data.</p>
    <p>Face Data is transmitted only for one-time processing and is not retained after processing is completed.</p>
    <p>Privacy Policy: <a href="https://replicate.com/privacy" target="_blank">https://replicate.com/privacy</a></p>

    <h3>3.2 Advertising & Analytics Partners</h3>
    <p>To measure advertising performance and understand the effectiveness of our marketing campaigns, we may share limited, non-face, non-identifying information (such as device information or aggregated usage data) with the following partner:</p>
    <ul>
        <li>Meta Platforms, Inc. (Facebook)</li>
        <li><a href="https://www.facebook.com/privacy/policy" target="_blank">https://www.facebook.com/privacy/policy</a></li>
    </ul>
    <p>Face Data and uploaded Media Content are never shared with advertising or analytics partners.</p>

    <h3>3.3 Legal and Safety Requirements</h3>
    <p>We may disclose information if required to comply with applicable laws, legal processes, or to protect the rights, safety, or property of users or the public.</p>

    <h2>4. Information Security</h2>
    <p>We implement reasonable technical and organizational measures to protect information from unauthorized access, disclosure, alteration, or destruction. Access to personal information is restricted to authorized personnel on a need-to-know basis.</p>

    <h2>5. Your Rights</h2>
    <p>Depending on applicable laws, you may have the right to:</p>
    <ul>
        <li>Access or correct your personal information</li>
        <li>Request deletion of your personal information</li>
    </ul>
    <p>You may submit requests by contacting us at:</p>
    <p>ops@novellettes.com</p>
    <p>Certain information may be retained where required by law or for legitimate security purposes.</p>

    <h2>6. Third-Party Links and Services</h2>
    <p>This Privacy Policy applies only to information collected by AI Swap.</p>
    <p>Third-party websites, platforms, or services are governed by their own privacy policies.</p>

    <h2>7. Policy Updates</h2>
    <p>We may update this Privacy Policy from time to time. Any changes will be reflected by an updated “Effective Date” at the top of this page. Material changes may be communicated through appropriate notices.</p>

    <h2>8. Contact Us</h2>
    <p>If you have any questions about this Privacy Policy or our data practices, please contact us at:</p>
    <p>ops@novellettes.com</p>
           
        
        `
    },
    ABOUT: {
        content: `
            <section>
                <p>If you need to cancel a purchase or have questions about your order, please contact us at ${getAppInfo().email}</p>
                <p>
                    To help us assist you faster, include your payment email and purchase date.
                </p>
                <p>
                    We’ll get back to you within 24 hours.
                </p>
               
            </section>
        `
    },
    AGREEMENT: {
        content: `
            <section>
                <h1>Clockwise Subscription Agreement</h1>
                <h3>Last Updated: [01.20.2025]</h3>
                <h3>1. Subscription Services</h3>
                <p>
                This Subscription Agreement ("Agreement") governs your access to [Novellettes] ("Service") provided by [ CLOCKWISE INTERNATIONAL (HONG KONG) LIMITED] ("Company," "we," or "us"). By subscribing, you ("User," "you") agree to be bound by these terms.
                </p>
                <h3>
                2. Subscription Plans & Auto-Renewal
                </h3>
                <p>
                Subscription Tiers:
                </p>
                <p>
                All subscription levels are subject to the actual payment page.
                </p>
                <p>
                First week discount, subsequent deductions will be based on the original price.
                </p>
                <p>
                Auto-Renewal:
                </p>
                <p>
                Subscription are automatically charged each billing period, whether weekly or another period, and you may be charged no more than 24 hours before the beginning of each billing period until you cancel your subscription.
                </p>
                <p>You authorize recurring charges to your designated payment method through Payermax until cancellation.</p>
                <h3>3. Payment Terms & No Free Trial</h3>
                <p>No Free Trial: The Service begins immediately upon payment confirmation. No free trial period is offered.</p>
                <p>Payment Processing:</p>
                <p>All fees are processed securely via Payermax. You agree to maintain valid and updated payment information.</p>
                <p>Prices are subject to change with 30 days’ notice. Continued use after notice constitutes acceptance.</p>
                <p>Non-Refundable Payments: All fees are final and non-refundable unless otherwise required by applicable law.</p>
                <h3>4. Cancellation & Refund Requests</h3>
                <p>Cancellation: To prevent auto-renewal, you must cancel your subscription through your account settings or email service@novellettes.com at least [1 days] before the next billing cycle.</p>
                <p>Refunds:</p>
                <p>Refund requests must be submitted via email to service@novellettes.com.</p>
                <p>Refunds are granted only if mandated by law (e.g., consumer protection regulations).</p>
                <h3>5. User Responsibilities</h3>
                <p>Ensure all account and billing information is accurate and current.</p>
                <p>Do not share accounts, reverse-engineer, or misuse the Service.</p>
                <h3>6. Termination</h3>
                <p>We reserve the right to suspend or terminate your subscription without prior notice for violations of this Agreement, fraudulent activity, or failure to pay fees.</p>
                <h3>7. Disclaimer & Liability</h3>
                <p>"As Is" Service: The Service is provided without warranties of any kind, express or implied.</p>
                <p>Limitation of Liability: We are not liable for indirect, incidental, or consequential damages arising from your use of the Service.</p>
                <h3>8. Governing Law & Amendments</h3>
                <p>Governing Law: This Agreement is governed by the laws of [HongKong].</p>
                <p>Updates: We may modify these terms with 30 days’ advance notice (via email or in-app notification). Continued use constitutes acceptance.</p>
                <h3>Acknowledgment</h3>
                <p>By subscribing, you confirm that you have read, understood, and agreed to this Agreement.</p>
            </section>
        
        `
    },
    'VIP_INTEREST': {
        1: `Enjoy 10000+ top books for unlimited free`,
        2: 'Release 200+ New Books every week',
        3: 'Enjoy Ad free privileges'
    },
    'VIP_RULES': {
        content: `
            <p>  Price: First week discount, subsequent deductions will be based on the original price.</p>
            <p>• Usage rules: Unsubscribed users can generate once for free.</p>
            <p>• Payment: The purchase will be charged to your app store account.</p>
            <p>• Renewal: Your subscription will renew automatically. Subscriptions are automatically charged each billing period, whether weekly or another period, and you may be charged no more than 24 hours before the beginning of each billing period until you cancel your subscription.</p>
            <p>• Cancellation: You may cancel a subscription at any time more than 24 hours before your renewal date.</p>
            <p>• Manage your subscriptions: You can view, change, or cancel your subscriptions.</p>
        `
    }
}